<template>
  <div id="preview" class="mt-2" >
     
    <b-img ref="previewImg" v-if="!isLoading"
      fluid-grow center block
      :src="getCurrentImage"
      alt="template preview" /> 
           
 <!-- LOADING SPINNER -->
      <div class="loadingSpinner text-center" v-if="isLoadingText != ''">
       
        <div v-html="isLoadingText" class="text-center mb-2"></div>
         <img src="/images/loading-dots.svg" alt="" width="40px">
      </div> 

  </div>

  
</template>

<script>
export default {
  name: "ShopVoucherTemplatePreview",
  props: [ "getSelectedItem"],
  data() { return {
    oldCustomMessage: '',
    oldTemplateId: undefined,
    customImage: undefined,
    isLoadingText: '',
    isLoading: true,
   
  }},
  methods: {
    setTemplate(template){
      this.getSelectedItem.selectedTemplate = template;
    },
    getVoucherPreviewFromServer(){
      if(this.getSelectedItem.count<1 &&  this.getSelectedItem.voucherType != 'priceList' && this.getSelectedItem.voucherType != 'personGroupPrices'){ 
       // console.log('skip rendering with count: 0', this.getSelectedItem);
        return;
       }
      // remember last message
      this.oldCustomMessage = this.getSelectedItem.customText;
      this.oldTemplateId = this.getSelectedItem.selectedTemplate.id;


        let data = {
              productId:    this.getSelectedItem.id,
              productType:  this.getSelectedItem.type,
              count:        this.getSelectedItem.count,
              requestShipping: this.getSelectedItem.requestShipping,
              templateId: this.getSelectedItem.selectedTemplate.id,
              customText:  this.getSelectedItem.customText,
              imageSize: 'big'
        };

        switch (this.getSelectedItem.voucherType) {
        case 'priceList':
          //console.log('Add Pricelist: ',this.getSelectedItem.selectedPrice, this.getSelectedItem.prices);

          if(!this.getSelectedItem.selectedPrice){
            data.selectedPrice = this.getSelectedItem.prices[0].title;
            
          }else{
            data.selectedPrice = this.getSelectedItem.selectedPrice;
          }
          //console.log('Selected Price:', data.selectedPrice );
          
          data.count = 1;
          break;
        case 'personGroupPrices':
          //console.log('Add personGroupPrices: ');
          data.personGroups = [];
          this.getSelectedItem.personGroups.forEach(element => {
            data.personGroups.push({
              id: element.id,
              numberOfPersons: element.prices[element.index].numberOfPersons
            });  
          });
          data.count = 1;
          break;
        case 'variablePrice':
          //console.log('Add variablePrice: ');
          data.selectedPrice = this.getSelectedItem.count;
          data.count = 1;
          break; 
        case 'fixedPrice':
          //console.log('Add fixedPrice: ');
          // nothing else to add
          break;
        default:
          break;
      }
      
      this.PostvoucherPreviewToServer(data);

    },    
    async PostvoucherPreviewToServer(params) {

      this.isLoadingText = 'Vorschau wird erstellt ...';
      //this.isLoading = true;


      let config = JSON.parse(JSON.stringify(this.$store.getters.getRestHeaderConfig));

      config.responseType = 'blob'; // arraybuffer
      
      //console.log('POST voucherPreview Params:', params,'config:', config);

      await this.$http
          .post(this.$store.getters.getRestServerBaseUrl + "/voucherPreview" , params , config)
          .then(response => {
              //console.log('voucherPreview OK: ', response);
              // Load binary data for image
              let reader = new FileReader();
              reader.readAsDataURL(response.data); 
              reader.onload = () => {
                  this.customImage = reader.result;
                  this.isLoadingText = '';
                  this.isLoading = false;
              }

          })
          .catch(err => {
              console.log("POST voucherPreview failed: ", err);
              this.isLoading = false;this.isLoadingText = '';
          });
    },
  },
  computed: {
    getSelectedLanguage() {
            return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() {
            return this.$store.getters.getLanguageStrings;
    },
    getCurrentImage() {
      // do we even have templates on this item?
      if (this.getSelectedItem.imageTemplates != undefined && this.getSelectedItem.imageTemplates.length > 0) {

        // is a template allready selected?
        if(this.getSelectedItem.selectedTemplate != undefined){
          //console.log('get Image selected Template: ' , this.getSelectedItem.selectedTemplate);
          // Custom Message requires rendering an image rather then using the original one

          if(this.getSelectedItem.customText != undefined ){ 

            if(this.oldCustomMessage != this.getSelectedItem.customText || this.oldTemplateId != this.getSelectedItem.selectedTemplate.id ){

             // console.log('Rendering new Image !'); 
               
              this.getVoucherPreviewFromServer();

              return this.customImage;
            }else{
                // no update
              return this.customImage;
            }
            
          }else{
            // use unmodified image from Template
            //console.log('unchanged text:');
            if(this.oldTemplateId != this.getSelectedItem.selectedTemplate.id){
              this.getVoucherPreviewFromServer();
            }else{
             // console.log('template not changed');
              
            }

            return this.customImage;
            //return this.$store.getters.getWebServerBaseUrl + this.getSelectedItem.selectedTemplate.image;
          }
         
        }else{
          //console.log('NO Template selected, use Template[0] image');
           
            this.setTemplate(this.getSelectedItem.imageTemplates[0]);
            
            
            this.getVoucherPreviewFromServer();

            return this.customImage;

          //return this.getSelectedItem.imageTemplates[0].image;
          
        }        

      }else{
        //console.log("NO Templates found, using ItemImage: " , this.getSelectedItem.images[0]);
        return (this.getSelectedItem.images[0]);
      }      
    }
  },
  beforeMount() {
    this.customImage = undefined;
    this.oldCustomMessage = undefined;
    this.getSelectedItem.customText ='';
    
 

  },
  mounted(){
    //console.log('Load default Image:');
    this.getSelectedItem.customText =' ';
   


    // make sure a Template is selected, if there are any
    if (this.getSelectedItem.imageTemplates != undefined && this.getSelectedItem.imageTemplates.length > 0) {

      if(this.getSelectedItem.selectedTemplate == undefined){
          this.getSelectedItem.selectedTemplate = this.getSelectedItem.imageTemplates[0];
          //console.log('bm selected first Template:', this.getSelectedItem.selectedTemplate);          
      }else{
        //console.log('bm Template was selected:', this.getSelectedItem.selectedTemplate);        
      }

      this.oldTemplateId = this.getSelectedItem.selectedTemplate.id;
    }else{
      //console.log('bm No Templates');      
    }
    
    this.getVoucherPreviewFromServer();  


  }
};
</script>
